import { FunctionComponent } from 'react';
 
const OveriddenMarginInfoCard: FunctionComponent = () => {
    return <><h3 className="text-primary-std font-medium">Overridden for this product</h3>
    <p className="text-secondary-std text-sm leading-tight">
    This value has been set specifically for this product. 
    All other values have been overridden by this.
    </p></>;
}
 
export default OveriddenMarginInfoCard;